(function () {
  if (typeof window.ShambhalaImpactStats !== 'undefined') return;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  class ShambhalaImpactStats {
    constructor(root) {
      this.root = root;
      this.cards = Array.from(root.querySelectorAll('[data-sis-card]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.started = new WeakSet();

      if (!this.cards.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const card = entry.target;
            card.classList.add('is-visible');
            this.animateCard(card);
            observer.unobserve(card);
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
      );

      this.cards.forEach((card) => observer.observe(card));
    }

    animateCard(card) {
      const numberEl = card.querySelector('[data-sis-number]');
      if (!numberEl || this.started.has(card)) return;

      this.started.add(card);

      const target = parseFloat(numberEl.dataset.sisTarget || '0');
      const decimals = parseInt(numberEl.dataset.sisDecimals || '0', 10);

      if (this.reducedMotion || Number.isNaN(target)) {
        numberEl.textContent = target.toFixed(decimals);
        return;
      }

      const duration = 1400;
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        const value = target * easeOutCubic(progress);
        numberEl.textContent = value.toFixed(decimals);

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          numberEl.textContent = target.toFixed(decimals);
        }
      };

      numberEl.textContent = (0).toFixed(decimals);
      requestAnimationFrame(tick);
    }
  }

  window.ShambhalaImpactStats = ShambhalaImpactStats;

  function initAll() {
    document.querySelectorAll('[data-shambhala-impact-stats]').forEach((root) => {
      if (root.__sisInstance) return;
      root.__sisInstance = new ShambhalaImpactStats(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
